module.exports = __webpack_public_path__ + "img/destination-cabo-san-lucas.e6d35f35.jpg";